<template>
  <div>
    <v-container grid-list-xs fluid>
      <v-layout justify-center row wrap>
        <v-flex xs6>
          <v-alert
            :value="true"
            color="success"
            icon="check_circle"
            outline
          >
            Correo electrónico verificado correctamente.
          </v-alert>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: 'verified-view',
    created () {
      console.log(this);
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/auth/verified.vue